/*
 *###############################################################################
 *Module Name                   : CashBookSummary.js                               #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  W M Shanika Chamodi                          #
 *Date                          :  Friday, December 12th 2022, 1:16:56 pm         #
 *Copyright © 2022 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */
import React, { useState } from "react"
import { Row, Col } from "reactstrap"

import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"

const CashbookCreditDebit = React.memo(({
  Disabled,
  LocationCode,
  CashBookDate,
  rowsCreditSummary,
  rowsDebitSummary,
  TotalCreditSummaryValue,
  TotalDebitSummaryValue,
  TotalCFValue
}) => {

  console.log("CashBookDate:", CashBookDate); // Print the value to the console

  return (
    <React.Fragment>

      <Row>

        <Col sm={12} md={5} className="mb-4-sm">Location Name</Col>
        <Col sm={12} md={5} className="mb-4-sm">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            textType="text"
            maxLength="8"
            textAlign="left"
            disabled={true}
            defaultValue="0.0"
            value={LocationCode}
          ></DPTextBoxforgrid>
        </Col>
        <Col sm={12} md={5} className="mb-4-sm">Cash Book For the period of</Col>
        <Col sm={12} md={5} className="mb-4-sm">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            textType="text"
            maxLength="8"
            textAlign="left"
            disabled={true}
            value={CashBookDate}
          ></DPTextBoxforgrid>
        </Col>
        <Col sm={12} md={5} className="mb-4-sm">
          <table
            style={{ fontSize: "12px" }}
            id={"CashBookDebitTable"}
          >
            <thead className="table-light-border">
              <tr>
                <th style={{ textAlign: "center" }}>Debit</th>
              </tr>
              <tr>
                <th>Transaction Details</th>
                <th style={{ textAlign: "right" }}>Amount</th>
              </tr>
            </thead>
            <tbody disabled={true}>
              {(rowsDebitSummary || []).map((dataRow, key) => (
                <TableRowDebitcashBook FormRow={dataRow} Key={key} Disabled={Disabled} />
              ))}

            </tbody>
            <tfoot>
              <th style={{ textAlign: "left" }}>Total Debit</th>
              <th style={{ textAlign: "right" }}>
                <DPTextBoxforgrid
                  rowClass="mb-12-sm"
                  labelText="Code"
                  textType="text"
                  maxLength="8"
                  textAlign="right"
                  disabled={true}
                  defaultValue="0.0"
                  value={TotalDebitSummaryValue.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
                ></DPTextBoxforgrid>
              </th>
            </tfoot>
          </table>

        </Col>
        <Col sm={12} md={5} className="mb-4-sm">

          <table
            style={{ fontSize: "12px" }}
            id={"CashBookCreditTable"}
          >
            <thead className="table-light-border">
              <tr>
                <th style={{ textAlign: "center" }}>Credit</th>
              </tr>
              <tr>
                <th>Transaction Details</th>
                <th style={{ textAlign: "right" }}>Amount</th>
              </tr>
            </thead>
            <tbody disabled={true}>
              {(rowsCreditSummary || []).map((dataRow, key) => (
                <TableRowCreditcashBook FormRow={dataRow} Key={key} Disabled={Disabled} />
              ))}
            </tbody>
            <tfoot>
              <tr>
                <th style={{ textAlign: "left" }}>Balance C/F</th>
                <th style={{ textAlign: "right" }}>
                  <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    labelText="Code"
                    textType="text"
                    maxLength="8"
                    textAlign="right"
                    disabled={true}
                    defaultValue="0.0"
                    value={TotalCFValue.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
                  ></DPTextBoxforgrid>
                </th>
              </tr>
              <tr>
                <th style={{ textAlign: "left" }}>Total Credit</th>
                <th style={{ textAlign: "right" }}>
                  <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    labelText="Code"
                    textType="text"
                    maxLength="8"
                    textAlign="right"
                    disabled={true}
                    defaultValue="0.0"
                    //value={(TotalCreditSummaryValue + TotalCFValue).toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
                    value={(parseFloat(TotalCreditSummaryValue) + parseFloat(TotalCFValue)).toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
                  ></DPTextBoxforgrid>
                </th>
              </tr>
            </tfoot>
          </table>
        </Col>

      </Row>
    </React.Fragment>
  )
})
export default CashbookCreditDebit
const TableRowDebitcashBook = ({ FormRow, Key, Disabled }) => {
  const [DebitTransaction, setDebitTransaction] = useState(
    FormRow.debitTransaction != undefined ? FormRow.debitTransaction : ""
  )
  const [DebitAmount, setDebitAmount] = useState(
    FormRow.debitamount != undefined ? FormRow.debitamount : "0.0"
  )
  return (
    <tr key={FormRow.id}>
      <td style={{ width: "350px" }}>

        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"txtDebitTransaction" + Key}
            value={DebitTransaction}
            onChange={e => {
              setDebitTransaction(e.target.value)
            }}
          ></DPTextBoxforgrid>
        </Col>

      </td>
      <td style={{ width: "100px" }}>

        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            defaultValue="0.0"
            textAlign="right"
            id={"txtDebitAmount" + Key}
            value={DebitAmount.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
            disabled={Disabled}

          ></DPTextBoxforgrid>
        </Col>

      </td>



    </tr>

  )
}
const TableRowCreditcashBook = ({ FormRow, Key, Disabled }) => {


  const [CreditTransaction, setCreditTransaction] = useState(
    FormRow.creditTransaction != undefined ? FormRow.creditTransaction : ""
  )
  const [CreditAmount, setCreditAmount] = useState(
    FormRow.creditamount != undefined ? FormRow.creditamount : "0.0"
  )

  return (
    <tr key={FormRow.id}>
      <td style={{ width: "350px" }}>

        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            textType="text"
            disabled={true}
            id={"txtCreditTransaction" + Key}
            value={CreditTransaction}
            onChange={e => {
              setCreditTransaction(e.target.value)
            }}
          ></DPTextBoxforgrid>
        </Col>

      </td>
      <td style={{ width: "100px" }}>

        <Col md="12">
          <DPTextBoxforgrid
            rowClass="mb-12-sm"
            labelText="Code"
            maxLength="10"
            defaultValue="0.0"
            textAlign="right"
            id={"txtCreditAmount" + Key}
            value={CreditAmount.toLocaleString(undefined, { maximumFractionDigits: 2, minimumFractionDigits: 2 })}
            disabled={Disabled}

          ></DPTextBoxforgrid>
        </Col>

      </td>



    </tr>
  )
}
